function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 26,
  cy: 26,
  r: 26,
  fill: "#5E12A0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6632 15.0565C41.3138 13.7337 40.1907 12.411 38.1691 10.9384C36.5469 9.76542 34.8248 9.09155 33.4521 9.09155C33.1775 9.09155 32.9279 9.11651 32.6784 9.16643C32.0544 9.29122 31.5053 9.74046 31.1559 10.4143C30.7316 11.213 30.6318 12.2862 30.9064 12.9351C31.0062 13.1347 31.131 13.3843 31.2807 13.609C29.9579 14.4076 29.2092 14.6322 29.1094 14.6572C32.5536 15.8053 35.4237 18.2012 37.2207 21.321L37.2457 21.0215C37.3206 20.1979 37.5701 19.2495 37.9195 18.2761C38.269 18.3759 38.6184 18.4258 38.9678 18.4258C39.8912 18.4258 40.6899 18.0515 41.189 17.3776C41.6882 16.7037 41.8879 15.8053 41.6632 15.0565Z",
  fill: "url(#paint0_linear_11733_190656)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0679 17.5517C40.3391 18.1756 41.2625 16.4285 40.963 15.2555C40.6386 14.0825 39.5903 12.8845 37.7434 11.5368C35.8965 10.189 34.0247 9.63997 32.8267 9.88955C31.6287 10.1391 31.2793 11.9611 31.5788 12.6599C31.7036 12.9344 31.9781 13.3338 32.3525 13.783C31.8783 14.1075 31.4291 14.357 31.0547 14.5817C33.3508 15.6049 35.3475 17.2022 36.8449 19.1989C37.0197 18.525 37.2692 17.926 37.4939 17.4019C37.6686 17.4269 37.8682 17.4768 38.0679 17.5517Z",
  fill: "url(#paint1_radial_11733_190656)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0609 42.01C32.7662 42.01 39.0124 35.7637 39.0124 28.0585C39.0124 20.3532 32.7662 14.1069 25.0609 14.1069C17.3556 14.1069 11.1094 20.3532 11.1094 28.0585C11.1094 35.7637 17.3556 42.01 25.0609 42.01Z",
  fill: "url(#paint2_radial_11733_190656)"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M39.8174 14.1079C37.9205 12.1113 36.3232 11.5872 34.4015 11.1629C32.904 10.8135 33.3033 9.9649 35.1253 10.1396C34.2517 9.84011 33.4281 9.76524 32.8291 9.89003C31.6311 10.1396 31.2817 11.9615 31.5812 12.6604C31.706 12.9349 31.9805 13.3342 32.3549 13.7835C31.681 14.2327 31.107 14.5572 30.6328 14.8068C30.8574 14.9066 31.132 15.0314 31.4564 15.2061C32.305 15.6553 33.2284 16.4041 33.2284 16.4041C31.8308 15.2061 32.1303 14.657 34.0521 13.3093C34.651 12.885 35.7492 12.9349 36.7725 13.459C37.7958 13.9831 38.9937 15.3059 38.9937 15.3059L37.8457 17.5022C37.9205 17.5272 37.9954 17.5521 38.0703 17.5771C38.7941 17.7768 39.3681 17.7268 39.8174 17.5521C40.3415 17.2277 41.7142 16.1295 39.8174 14.1079Z",
  fill: "#A98698",
  fillOpacity: 0.6
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M34.3696 12.3607C34.8688 12.5604 35.5177 12.9098 36.3163 13.4339C37.2647 14.0579 38.0883 14.7567 38.6125 15.3058C37.7389 16.4539 37.1649 18.0262 36.8155 19.1244C36.9902 19.3739 37.1898 19.6235 37.3646 19.8731C37.5393 19.2492 37.8388 18.3257 38.2381 17.4023C38.3379 17.4272 38.4627 17.4272 38.5875 17.4272C38.887 17.4272 39.2364 17.3773 39.5109 17.1527C39.7106 17.0029 39.9352 16.7284 39.9103 16.2292C39.9103 15.755 39.5359 15.156 38.7622 14.4323C38.2131 13.9081 37.4644 13.3341 36.7156 12.81C34.5693 11.3874 33.0718 10.9881 32.3979 11.6619C31.9487 12.1112 31.9986 12.6602 32.1483 13.0596C31.3497 13.5837 30.6758 13.9581 30.2266 14.2076C30.5261 14.3075 30.8006 14.4323 31.1001 14.5571C31.8987 14.1328 33.0468 13.409 34.3696 12.3607ZM39.0867 15.9297C39.1615 16.0545 39.1865 16.1793 39.1865 16.2542C39.1865 16.4788 39.1116 16.5537 39.0617 16.6036C38.9619 16.6785 38.7622 16.7284 38.5875 16.7284C38.7372 16.4289 38.9119 16.1793 39.0867 15.9297ZM32.922 12.211C32.9969 12.1361 33.1966 12.0862 33.521 12.1361C33.2714 12.3358 33.0219 12.5105 32.7723 12.6852C32.7473 12.5105 32.7723 12.3358 32.922 12.211Z",
  fill: "#5E12A0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0642 13.2837C16.9029 13.2837 10.2891 19.8976 10.2891 28.0588C10.2891 36.2201 16.9029 42.834 25.0642 42.834C33.2255 42.834 39.8393 36.2201 39.8393 28.0588C39.8393 19.8976 33.2005 13.2837 25.0642 13.2837ZM25.0642 42.0104C17.3522 42.0104 11.1127 35.7708 11.1127 28.0588C11.1127 20.3468 17.3522 14.1073 25.0642 14.1073C32.7762 14.1073 39.0157 20.3468 39.0157 28.0588C39.0157 35.7708 32.7513 42.0104 25.0642 42.0104Z",
  fill: "#5E12A0"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M25.0609 42.01C32.7662 42.01 39.0124 35.7637 39.0124 28.0585C39.0124 20.3532 32.7662 14.1069 25.0609 14.1069C17.3556 14.1069 11.1094 20.3532 11.1094 28.0585C11.1094 35.7637 17.3556 42.01 25.0609 42.01Z",
  fill: "url(#paint3_linear_11733_190656)"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M24.9656 40.3137C17.3534 39.0908 12.1871 31.9279 13.435 24.3157C13.984 20.9463 15.6812 18.0762 18.0772 16.0046C14.583 18.0262 11.9874 21.5453 11.2886 25.8381C10.0656 33.4503 15.2319 40.6132 22.8192 41.8362C27.062 42.535 31.1551 41.2122 34.1751 38.6166C31.5046 40.164 28.26 40.8379 24.9656 40.3137Z",
  fill: "#A98698",
  fillOpacity: 0.6
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2837 14.3069C23.7646 13.7329 20.3454 14.5315 17.5501 16.3036C17.5002 16.3535 17.4502 16.4034 17.4502 16.4034C18.5234 15.7545 20.0958 15.1804 20.0958 15.1804C16.0526 17.5265 14.8047 20.197 14.8047 20.197C16.377 17.1521 20.9943 15.0057 24.6132 14.856C28.2321 14.7062 30.6031 15.7794 33.4982 18.1005C36.3934 20.4466 38.1404 25.2385 37.9657 29.0321C37.816 32.8258 35.8193 35.8956 35.8193 35.8956C37.192 34.1236 38.0156 32.8258 38.5398 31.503C38.6396 31.1037 38.7394 30.7043 38.7893 30.28C40.0372 22.6928 34.8959 15.5299 27.2837 14.3069Z",
  fill: "url(#paint4_linear_11733_190656)"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M38.3194 27.9341C38.3194 35.2468 32.3794 41.1868 25.0667 41.1868C17.754 41.1868 11.7891 35.2468 11.7891 27.9341H38.3194Z",
  fill: "url(#paint5_linear_11733_190656)"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M37.2676 27.9341C37.2676 35.0721 31.6271 40.9122 24.5391 41.1868H25.0632C32.3759 41.1868 38.3159 35.2468 38.3159 27.9341H37.2676Z",
  fill: "url(#paint6_linear_11733_190656)"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6609 27.9341H11.7891C11.7891 35.2468 17.7291 41.1868 25.0418 41.1868C25.3662 41.1868 25.6657 41.1868 25.9652 41.1618C19.1018 40.6627 13.6609 34.9223 13.6609 27.9341Z",
  fill: "url(#paint7_linear_11733_190656)"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M38.2945 28.0593C38.2945 26.5369 35.6489 25.6633 32.1298 25.3638C29.5841 25.1642 27.0134 25.4137 24.0684 26.3122C21.5227 27.061 19.2265 26.9362 17.5544 26.7365C13.8356 26.3122 11.7891 26.2623 11.7891 28.0593C11.7891 30.6549 17.0802 33.8995 25.0168 32.7764C29.035 32.2023 31.1066 31.0293 33.4776 30.2306C36.0482 29.3821 38.2945 29.407 38.2945 28.0593Z",
  fill: "url(#paint8_linear_11733_190656)"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M29.4025 21.7695C30.6431 21.7695 31.6487 20.764 31.6487 19.5233C31.6487 18.2827 30.6431 17.2771 29.4025 17.2771C28.1618 17.2771 27.1562 18.2827 27.1562 19.5233C27.1562 20.764 28.1618 21.7695 29.4025 21.7695Z",
  fill: "white"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0734 23.4412C33.5973 23.4412 34.0218 23.0167 34.0218 22.4928C34.0218 21.969 33.5973 21.5444 33.0734 21.5444C32.5495 21.5444 32.125 21.969 32.125 22.4928C32.125 23.0167 32.5495 23.4412 33.0734 23.4412Z",
  fill: "white"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M36.4737 17.7269H36.4238C36.274 17.7019 36.1742 17.5522 36.1991 17.3775C36.4238 16.2294 37.3722 15.1313 37.4221 15.0813C37.5219 14.9566 37.7216 14.9566 37.8214 15.0564C37.9462 15.1562 37.9462 15.3559 37.8464 15.4557C37.8214 15.4807 36.9479 16.504 36.7482 17.5023C36.7233 17.652 36.5985 17.7269 36.4737 17.7269Z",
  fill: "url(#paint9_linear_11733_190656)"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M33.4477 9.09103C34.8454 9.09103 36.5675 9.7649 38.1648 10.9379C40.1864 12.4104 41.3095 13.7083 41.6589 15.056C41.8586 15.8297 41.6839 16.7032 41.1847 17.3521C40.6606 18.026 39.8869 18.4004 38.9635 18.4004C38.639 18.4004 38.2896 18.3505 37.9152 18.2506C37.6906 18.8247 37.5159 19.3987 37.3911 19.9478C38.9135 22.2689 39.812 25.0642 39.812 28.0591C39.812 36.2204 33.1982 42.8343 25.0369 42.8343C16.8756 42.8343 10.2867 36.2204 10.2867 28.0591C10.2867 19.8978 16.9006 13.284 25.0618 13.284C26.8588 13.284 28.5809 13.6084 30.1782 14.2074C30.4777 14.0577 30.8521 13.858 31.2764 13.6084C31.1266 13.3838 30.9769 13.1592 30.902 12.9346C30.6275 12.2607 30.7273 11.2125 31.1516 10.4138C31.501 9.7649 32.0251 9.31566 32.674 9.16591C32.8987 9.11599 33.1732 9.09103 33.4477 9.09103ZM33.4477 8.66675C33.1482 8.66675 32.8487 8.69171 32.5742 8.76658C31.8255 8.94129 31.1766 9.44045 30.7523 10.2391C30.2781 11.1625 30.1533 12.3605 30.4777 13.1342C30.5276 13.2341 30.5776 13.3589 30.6524 13.4836C30.4777 13.5835 30.303 13.6833 30.1283 13.7582C28.4811 13.1841 26.7839 12.8847 25.0369 12.8847C22.9903 12.8847 20.9937 13.284 19.1218 14.0826C17.2999 14.8563 15.6776 15.9545 14.28 17.3521C12.8823 18.7498 11.7842 20.3721 11.0105 22.194C10.2118 24.0658 9.8125 26.0625 9.8125 28.109C9.8125 30.1556 10.2118 32.1522 11.0105 34.0241C11.7842 35.846 12.8823 37.4683 14.28 38.8659C15.6776 40.2636 17.2999 41.3617 19.1218 42.1354C20.9937 42.9341 22.9903 43.3334 25.0369 43.3334C27.0834 43.3334 29.0801 42.9341 30.9519 42.1354C32.7739 41.3617 34.3961 40.2636 35.7938 38.8659C37.1914 37.4683 38.2896 35.846 39.0633 34.0241C39.8619 32.1522 40.2613 30.1556 40.2613 28.109C40.2613 25.1889 39.4377 22.3687 37.8653 19.9228C37.9402 19.5484 38.065 19.1741 38.1898 18.7997C38.4393 18.8496 38.7139 18.8746 38.9635 18.8746C40.0117 18.8746 40.9351 18.4503 41.5341 17.6516C42.1082 16.9029 42.3328 15.8547 42.0832 14.9811C41.6839 13.5336 40.5358 12.1609 38.4144 10.6384C36.7422 9.36557 34.9203 8.66675 33.4477 8.66675Z",
  fill: "white"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1441 38.4663C24.53 38.4663 24.843 38.1533 24.843 37.7674C24.843 37.3816 24.53 37.0686 24.1441 37.0686C23.7583 37.0686 23.4453 37.3816 23.4453 37.7674C23.4453 38.1533 23.7583 38.4663 24.1441 38.4663Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M23.7432 38.2171C23.4687 37.9426 23.4687 37.4933 23.7432 37.2188C23.7932 37.1689 23.8431 37.1439 23.893 37.094C23.7932 37.119 23.7183 37.1689 23.6434 37.2437C23.3689 37.5183 23.3689 37.9675 23.6434 38.2421C23.868 38.4667 24.2174 38.5166 24.492 38.3669C24.2424 38.4667 23.9429 38.4168 23.7432 38.2171Z",
  fill: "url(#paint10_linear_11733_190656)"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M24.3919 37.5683C24.4745 37.5683 24.5417 37.5012 24.5417 37.4185C24.5417 37.3359 24.4745 37.2688 24.3919 37.2688C24.3093 37.2688 24.2422 37.3359 24.2422 37.4185C24.2422 37.5012 24.3093 37.5683 24.3919 37.5683Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M27.7848 38.1169C28.1706 38.1169 28.4836 37.8039 28.4836 37.4181C28.4836 37.0322 28.1706 36.7192 27.7848 36.7192C27.3989 36.7192 27.0859 37.0322 27.0859 37.4181C27.0859 37.8039 27.3989 38.1169 27.7848 38.1169Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M27.3839 37.8677C27.1093 37.5932 27.1093 37.144 27.3839 36.8694C27.4338 36.8195 27.4837 36.7945 27.5336 36.7446C27.4338 36.7696 27.3589 36.8195 27.284 36.8944C27.0095 37.1689 27.0095 37.6182 27.284 37.8927C27.5087 38.1173 27.8581 38.1672 28.1326 38.0175C27.883 38.1173 27.5835 38.0674 27.3839 37.8677Z",
  fill: "url(#paint11_linear_11733_190656)"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M28.0326 37.2189C28.1152 37.2189 28.1823 37.1518 28.1823 37.0692C28.1823 36.9866 28.1152 36.9194 28.0326 36.9194C27.9499 36.9194 27.8828 36.9866 27.8828 37.0692C27.8828 37.1518 27.9499 37.2189 28.0326 37.2189Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9851 39.7396C26.2746 39.7396 26.5092 39.505 26.5092 39.2155C26.5092 38.926 26.2746 38.6914 25.9851 38.6914C25.6955 38.6914 25.4609 38.926 25.4609 39.2155C25.4609 39.505 25.6955 39.7396 25.9851 39.7396Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M25.6856 39.5397C25.4859 39.34 25.4859 38.9906 25.6856 38.7909C25.7105 38.766 25.7604 38.741 25.7854 38.7161C25.7105 38.741 25.6606 38.7909 25.6107 38.8409C25.411 39.0405 25.411 39.3899 25.6107 39.5896C25.7854 39.7643 26.035 39.7893 26.2596 39.6645C26.0599 39.7393 25.8353 39.6894 25.6856 39.5397Z",
  fill: "url(#paint12_linear_11733_190656)"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M26.1623 39.0405C26.2175 39.0405 26.2622 38.9958 26.2622 38.9407C26.2622 38.8855 26.2175 38.8408 26.1623 38.8408C26.1072 38.8408 26.0625 38.8855 26.0625 38.9407C26.0625 38.9958 26.1072 39.0405 26.1623 39.0405Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M29.2038 39.3651C29.4933 39.3651 29.7279 39.1305 29.7279 38.841C29.7279 38.5515 29.4933 38.3169 29.2038 38.3169C28.9143 38.3169 28.6797 38.5515 28.6797 38.841C28.6797 39.1305 28.9143 39.3651 29.2038 39.3651Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M28.9043 39.1659C28.7046 38.9662 28.7046 38.6168 28.9043 38.4172C28.9293 38.3922 28.9792 38.3672 29.0041 38.3423C28.9293 38.3672 28.8794 38.4172 28.8294 38.4671C28.6298 38.6667 28.6298 39.0162 28.8294 39.2158C29.0041 39.3905 29.2537 39.4155 29.4783 39.2907C29.2787 39.3656 29.0541 39.3156 28.9043 39.1659Z",
  fill: "url(#paint13_linear_11733_190656)"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M29.3811 38.666C29.4362 38.666 29.4809 38.6213 29.4809 38.5661C29.4809 38.511 29.4362 38.4663 29.3811 38.4663C29.3259 38.4663 29.2812 38.511 29.2812 38.5661C29.2812 38.6213 29.3259 38.666 29.3811 38.666Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M21.1715 38.217C21.8057 38.217 22.3196 37.7031 22.3196 37.069C22.3196 36.435 21.8057 35.9209 21.1715 35.9209C20.5376 35.9209 20.0234 36.435 20.0234 37.069C20.0234 37.7031 20.5376 38.217 21.1715 38.217Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M20.5179 37.7928C20.0687 37.3436 20.0687 36.6198 20.5179 36.1706C20.5928 36.0957 20.6677 36.0458 20.7675 35.9958C20.6178 36.0458 20.493 36.1456 20.3682 36.2454C19.9189 36.6947 19.9189 37.4185 20.3682 37.8677C20.7426 38.2421 21.3166 38.3169 21.7658 38.0424C21.3415 38.2171 20.8424 38.1422 20.5179 37.7928Z",
  fill: "url(#paint14_linear_11733_190656)"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5699 36.7194C21.7077 36.7194 21.8195 36.6076 21.8195 36.4698C21.8195 36.332 21.7077 36.2202 21.5699 36.2202C21.4321 36.2202 21.3203 36.332 21.3203 36.4698C21.3203 36.6076 21.4321 36.7194 21.5699 36.7194Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4293 35.3967C32.0635 35.3967 32.5774 34.8828 32.5774 34.2487C32.5774 33.6147 32.0635 33.1006 31.4293 33.1006C30.7954 33.1006 30.2812 33.6147 30.2812 34.2487C30.2812 34.8828 30.7954 35.3967 31.4293 35.3967Z",
  fill: "white",
  fillOpacity: 0.2
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M30.7523 34.9723C30.3031 34.523 30.3031 33.7992 30.7523 33.35C30.8272 33.2751 30.9021 33.2252 31.0019 33.1753C30.8521 33.2252 30.7273 33.325 30.6026 33.4249C30.1533 33.8741 30.1533 34.5979 30.6026 35.0471C30.9769 35.4215 31.551 35.4964 32.0002 35.2218C31.5759 35.3966 31.1017 35.3217 30.7523 34.9723Z",
  fill: "url(#paint15_linear_11733_190656)"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M31.8277 33.8991C31.9655 33.8991 32.0773 33.7873 32.0773 33.6495C32.0773 33.5117 31.9655 33.3999 31.8277 33.3999C31.6899 33.3999 31.5781 33.5117 31.5781 33.6495C31.5781 33.7873 31.6899 33.8991 31.8277 33.8991Z",
  fill: "white",
  fillOpacity: 0.3
});

var _ref38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_11733_190656",
  x1: 29.1094,
  y1: 15.2063,
  x2: 41.7549,
  y2: 15.2063,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA800"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF5107"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_11733_190656",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(40.5078 13.6831) scale(11.1548 11.1548)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEAFF",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#A087C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10002F"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint2_radial_11733_190656",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(34.298 18.44) scale(27.2918)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFEAFF",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.68,
  stopColor: "#A087C9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#10002F"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_11733_190656",
  x1: 22.823,
  y1: 41.8121,
  x2: 27.2854,
  y2: 14.2816,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#81FFFF",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_11733_190656",
  x1: 34.8946,
  y1: 18.5839,
  x2: 23.358,
  y2: 29.169,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_11733_190656",
  x1: 11.8003,
  y1: 34.5527,
  x2: 38.3129,
  y2: 34.5527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0002E9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF00C7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_11733_190656",
  x1: 39.5645,
  y1: 29.097,
  x2: 25.1337,
  y2: 42.7349,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_11733_190656",
  x1: 11.8003,
  y1: 34.5527,
  x2: 25.9845,
  y2: 34.5527,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000292",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7D00C7",
  stopOpacity: 0.7
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_11733_190656",
  x1: 11.8181,
  y1: 29.1603,
  x2: 38.2953,
  y2: 29.1603,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#000292"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#BE00C7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_11733_190656",
  x1: 37.8618,
  y1: 14.9598,
  x2: 35.959,
  y2: 18.0521,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_11733_190656",
  x1: 23.4368,
  y1: 37.7893,
  x2: 24.4927,
  y2: 37.7893,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_11733_190656",
  x1: 27.0749,
  y1: 37.4352,
  x2: 28.1308,
  y2: 37.4352,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_11733_190656",
  x1: 25.4577,
  y1: 39.2212,
  x2: 26.2504,
  y2: 39.2212,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_11733_190656",
  x1: 28.6656,
  y1: 38.8464,
  x2: 29.4584,
  y2: 38.8464,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_11733_190656",
  x1: 20.0198,
  y1: 37.0982,
  x2: 21.7442,
  y2: 37.0982,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_11733_190656",
  x1: 30.2637,
  y1: 34.2769,
  x2: 31.9882,
  y2: 34.2769,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.29,
  stopColor: "white",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "white",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

function SvgOsmoGradient(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmoGradient);
export default __webpack_public_path__ + "static/media/OSMOGradient.2ac627ed3aff383de190a4e0bbefd07e.svg";
export { ForwardRef as ReactComponent };